import React, { useEffect, useRef, useState } from 'react';
import QrScanner from 'qr-scanner';
import { BrowserRouter as Router, Route, Link, useParams, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { AxiosInstance } from '../utils';

QrScanner.WORKER_PATH = '/qr-scanner-worker.min.js'; // adjust based on your public folder

const QRScanner = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [scanResult, setScanResult] = useState('');
  const [apiResponse, setApiResponse] = useState<any>(null);
  const [scanner, setScanner] = useState<QrScanner | null>(null);
  const [listCameras, setListCameras] = useState([] as any);
  const [selectedCameraId, setSelectedCameraId] = useState<string>('');
  const { eventcode,checkinkey, checkinfield } = useParams();
  useEffect(() => {
 

    listcamra();},[])

  useEffect( () => {
 
    if (!videoRef.current) return;
  
        
    const qr = new QrScanner(
      videoRef.current,
      async result => {
        console.log('QR Code:', result.data);
        setScanResult(result.data);
        qr.stop();

        try {
          let requestReq = {
            'eventcode': eventcode,
            'checkinfield': checkinfield,
            'checkinkey': checkinkey,
            'qrdata': result.data
        };
        const { data: response } = await AxiosInstance.post('/api/postcheckin', requestReq, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.result == "Success") {
            toast.info("Success.");
        }
        else{
            toast.error(response.msg);
        }
          setApiResponse(response);
          qr.start();
          
        } catch (err) {
          console.error('API error:', err);
          qr.start();
        }
      },
      {
        highlightScanRegion: true,
        highlightCodeOutline: true,
        returnDetailedScanResult: true
      }
    );
    setScanner(qr);

    QrScanner.hasCamera().then(hasCam => {
      if (hasCam) 
      {console.log( "start it"); qr.start().catch(console.error);}
      else console.error('No camera found');
    });

    return () => {
      qr.stop();
      qr.destroy();
    };

  }, []);


 const listcamra = async () => {
  const cameraList = await QrScanner.listCameras(true);
  setListCameras(cameraList);
  console.log(cameraList);
  setSelectedCameraId(cameraList[0].id)
  }
  const onCameraChange = async (cameraid)=>{
 await scanner?.setCamera(cameraid);
    setSelectedCameraId(cameraid);
  }
  return (
    <div  className="container">
    <div  className="register-sec-details  white-heading-text">
  <div className="row">
                    <div className="col-lg-5">
                    <span className="ticketsummary-header">Select a Camera :  </span><br/>
<select   className="form-field form-label-group-cust  camera-dropdown" value={selectedCameraId} onChange={(e) => onCameraChange(e.target.value)}>
  {listCameras.map((camera) => (
      
    <option key={camera.id} value={camera.id}>
      {camera.label || 'Unnamed Camera'}
    </option>
  ))
  }
</select>
</div>
</div>
<div className="row">
			<div className="col-xs-12 col-md-6 col-lg-6 col-xl-3 my-1 text-center">
      < video  className="rounded border shadow videolayout w-100"
 ref={videoRef}  />
</div>
</div>
{apiResponse && <>
    <div className="row p-2 white-heading-text">
                    <div className="col-lg-6">
                        <span className="normal-info">Status : </span><span className={apiResponse.result=="Success"?"success-info":"failed-info"} >{apiResponse.result}</span>
                         </div>
                        </div>
                        <div className="row  p-2">
                    <div className="col-lg-6">
                        <span className="normal-info">Message : </span><span className={apiResponse.result=="Success"?"success-info":"failed-info"} >{apiResponse.msg}</span>
                        </div>
                        </div>
                        <div className="row  p-2">
                    <div className="col-lg-6">
                        <span className="normal-info">Metadata :  </span>
                
                <table>
                   
                        {Object.entries(apiResponse.data).map(([key, value]) => (
         <tr>
             <td className="normal-info p-1">{key}</td>
             <td className="normal-info-bold p-1">{String(value)}</td>
         </tr>
  
  ))}</table>
                        </div>
                        </div>
</>}
</div>
    </div>
  );
};

export default QRScanner;
